<template>
  <div>
    <div :id="id" :style="{height: '400px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    data: {
      type: Array,
      default: () => []
    },
    xData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      item: {
        0: '',
        1: '',
        2: '',
        3: '',
        4: ''
      }
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.$nextTick(() => {
          this.drawLine(newValue)
        })
      },
      immediate: true,
    },
  },
  methods: {
    drawLine (dataPic) {
      // 处理图例按钮显示
      let legendList = dataPic.map(item => item.name)
      // 根据每组 数组 数据最大值 的 位数，判断左右轴
      let list = dataPic.map(item => {
        return {
          name: item.name,
          data: Math.max(...item.data),
          maxLength: Math.max(...item.data).toString().split('.')[0].length
        }
      })
      list = list.sort((a, b) => {
        return b.maxLength - a.maxLength
      })
      if(list.every(item => item.maxLength === list[0].maxLength)) {
        dataPic.forEach (item => { item.yAxisIndex = 0 })
      } else if(dataPic.length <= 2) {
        dataPic.forEach((item,i) => {item.yAxisIndex = i})
      } else {
        let arr = dataPic.length === 3 ? [list[0].name] : [list[0].name, list[1].name]
        dataPic.forEach(item => {
          item.smooth = true
          if (arr.includes(item.name)){
            item.yAxisIndex = 0
          } else {
            item.yAxisIndex = 1
          }
        })
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
        // title: {
        //   text: 'Stacked Line'
        // },
        color : [ '#3377FF', '#FFAC52', '#ADCD40', '#FF5D5D', '#67BFFF' ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderWidth:'1',
          borderColor:'gray',
          axisPointer: {
            type: 'shadow'
          },
          textStyle:{
            color:'black',
          },
          formatter:(params) => {
            Object.keys(this.item).forEach(itemIndex => {
              this.item[itemIndex] = ''
            })
            let unit = ''
            for( var i = 0; i<params.length; i++){
              switch (params[i].seriesName) {
                case '已核销券人数':
                  unit = '人'
                  break
                case '已核销券金额':
                case '券贡献加油金额':
                case '券平均加油金额':
                case '待核销券金额': 
                case '已过期券金额':
                  unit = '元'
                  break
                case '已核销券张数':
                case '待核销券张数':
                case '已过期券张数':
                  unit = '张'
                  break
                case '券平均核销时间':
                  unit = '天'
                  break
                case '券贡献加油升数':
                  unit = '升'
                  break
                case '券贡献加油笔数':
                  unit = '笔'
                  break
              }
              this.item[i] = params[i].seriesName + ':' + params[i].value + unit + "<br/>"
            }
            const head = params[0].axisValueLabel + "<br/>"
            return `${head}${this.item[0]}${this.item[1]}${this.item[2]}${this.item[3]}${this.item[4]}`
          },
        },
        legend: {
          data: legendList,
          right: '5%'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xData
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                type:'dashed',
                color:'#EAEAEA'
              }
            },
            axisLabel: {
              formatter: '{value}',
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false
            }
          },
          {
            axisLabel: {
              formatter: '{value}',
            },
            splitLine: {
              lineStyle: {
                type:'dashed',
                color:'#EAEAEA'
              }
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false
            }
          }  
        ],
        series: dataPic
      }, true)
    }
  }
}
</script>
<style scoped lang="less">

</style>